export default {
  screen_log: {
    id: "Id",
    code: "암호",
    name: "이름",
    description: "기술",
    active: "Active",
    createdAt: "작성 시간",
    updatedAt: "에 업데이트 됨",
    create: "새 화면 로그 만들기",
    update: "화면 로그 업데이트",
    title: "로그 할 화면 선택",
    caption: "화면 로그 관리",
  }
}